import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, takeWhile, timeout } from 'rxjs';
import { FILE_UPLOAD_TIMEOUT, generateRandomString } from 'src/app/constants';
import { DashboardService } from 'src/app/services/dashboard.service';
import { WebSocketService } from 'src/app/services/websocket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-delay-dispatch',
  templateUrl: './delay-dispatch.component.html',
  styleUrls: ['./delay-dispatch.component.scss'],
  standalone: false // NOSONAR
})
export class DelayDispatchComponent implements OnInit {

  successMessage: any;
  errorMessage: any;
  fileName = '';
  upload: boolean = false;
  res: any;
  selectedFileName: any;
  selectedFilePath: any;
   mssg = 'File is not uploaded...please try again'
  constructor(
     private  readonly dashboardService : DashboardService,
    public dialogRef: MatDialogRef<DelayDispatchComponent>,
    private readonly webSocketService: WebSocketService
  ) {

  }

  ngOnInit(): void {
    console.info('something')
  }

  close(): void {
    this.dialogRef.close({ event: 'CloseEvent' });
  }


  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.xlsx' || extension.toLowerCase() == '.xls' ) {  // NOSONAR
      this.dashboardService.uploadDelayedDispatchFile(file).subscribe((response) => {
        this.res = response;
        if (this.res.status == 200) {  // NOSONAR
          this.upload = true;
        }
        else {
          this.upload = false;
          this.errorMessage = this.mssg;

        }
      })
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .xlsx and .xls';
    }
  }

  async newonFileSelected(event: any) {
    const file: File = event.target.files[0];
    this.fileName = file.name;
    this.upload = false;
    const extension = this.fileName.substring(this.fileName.lastIndexOf('.'));
    if (extension.toLowerCase() == '.xlsx' || extension.toLowerCase() == '.xls' ) {  // NOSONAR
      const parsedFileName = this.fileName
        ?.replace(/\s+/g, '_') // Replace spaces with underscore
        ?.replace(/[^a-zA-Z0-9._]/g, '_'); // Replace all non-alphanumeric/safe characters with underscore
      this.selectedFileName = `${generateRandomString()}_${parsedFileName}`;
      this.selectedFilePath = `AET/DelayDispatch/${this.selectedFileName}`;
      try {
        this.webSocketService.connect();
        await this.webSocketService.waitUntilSocketConnected();
        console.info(
          'WebSocket connected:',
          this.webSocketService.isSocketConnected()
        );
        this.webSocketService.sendMessage(
          // JSON.stringify({
          { fileName: this.selectedFilePath }
          // })
        );
        const url = `${environment.FILE_UPLOAD_URI}/${this.selectedFilePath}`;
        const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
        const upn = fgaDetails?.user?.userPrincipalName;

        const uploadHeaders: any = {
          'Content-Type': file?.type, // Set file content type
          'x-auth-token': sessionStorage.getItem('accessToken'),
          'x-amz-meta-userid': upn

        };

        const response = await fetch(url, {
          method: 'PUT',
          headers: uploadHeaders,
          body: file,
        });

        if (!response.ok) {
          this.errorMessage = 'Failed to upload file!'
          this.webSocketService.closeConnection();
          return;
        }

        this.webSocketService
          .receiveMessages()
          .pipe(
            // If no message is received within 25 seconds, throw TimeoutError
            timeout({
              each: FILE_UPLOAD_TIMEOUT, // 25 seconds between messages
            }),
            takeWhile( (msg) => msg.status != 'success' && msg.status != 'failed' && msg.status != 'error', true ), // NOSONAR
            catchError((err) => {
              if (err.name == 'TimeoutError') {  // NOSONAR
                console.info(
                  `No message received in ${FILE_UPLOAD_TIMEOUT / 1000
                  } seconds. Closing connection.`
                );
                this.webSocketService.closeConnection();
                this.errorMessage = 'Failed to upload file. Please re-upload the file.'
              } else {
                console.info('WebSocket error:', err);
              }
              return EMPTY; // Stop further emissions
            })
          )
          .subscribe((messages: any) => {
            console.info(messages, "messages from Lambda");

            const backendResp = messages.backendResponse;
            try {
              if (backendResp) {
                // Check backend API response for success/failure

                this.res = backendResp;
                if (this.res.status == 200) {  // NOSONAR
                  this.upload = true;
                }
                else {
                  this.upload = false;
                  this.errorMessage = this.mssg;

                }

              }
            }
            catch {
              this.upload = false;
              this.errorMessage = this.mssg;
            }
            this.webSocketService.closeConnection();
          })
      } catch (err) {
        this.upload = false;
        console.info('Unexpected upload exception:', err);
        this.webSocketService.closeConnection();
        this.errorMessage = 'An unexpected error occurred. Please retry. Contact IS Service Desk if error persists'
      }
    } else {
      this.upload = false;
      this.errorMessage = 'Can accept only .xlsx and .xls';
    }
  }

  closeNotif() {
    this.errorMessage = null;
    this.successMessage = null;
  }

}
